import { Directive } from '@angular/core';

@Directive({
  selector: '[appOnlyLetters]',
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(keydown)': 'onInputChange($event)',
    '(input)': 'onInputChange($event)',
  },
  standalone: false,
})
export class OnlyLettersDirective {
  constructor() {}

  onInputChange(event) {
    if (event && event.key) {
      if (event.key.match(/^[A-zÀ-ÖØ-öø-ÿ'-\s]+$/)) {
        return true;
      } else {
        return false;
      }
    } else if (event) {
      if (event.target.value.match(/^[A-zÀ-ÖØ-öø-ÿ'-\s]+$/)) {
        return true;
      } else {
        event.target.value = event.target.value.substr(0, event.target.value.length - 1);
        return false;
      }
    }
  }
}
